function copyDiscountCode(index) {
  var codeElement = document.getElementById("discountCode" + index);
  var code = codeElement.textContent;

  navigator.clipboard.writeText(code).then(function () {
    // Show "Code copied!" below coupon
    var msg = document.getElementById("copyMessage" + index);
    msg.style.display = "block";

    setTimeout(() => { msg.style.display = "none"; }, 2000);

    // Show notification bar
    var bottomMsg = document.getElementById("discountMessage");
    bottomMsg.textContent = "✅ Discount code " + code + " copied!";
    bottomMsg.style.bottom = "20px";

    setTimeout(() => {
      bottomMsg.style.bottom = "-80px";
    }, 2500);
  });
}

window.addEventListener('scroll', function () {
    const modal = document.getElementById('modal_st');
      const header = document.getElementById('header_open_st');
        const scrolled = window.scrollY > 50; // <-- increased threshold
          const isMobile = window.innerWidth <= 768; // adjust breakpoint if needed

            // #modal_st: visible at top, hidden on scroll (only on mobile)
              if (modal) {
                  if (isMobile) {
                        modal.style.visibility = scrolled ? 'hidden' : 'visible';
                            } else {
                                  modal.style.visibility = 'visible'; // always visible on desktop
                                      }
                                        }

                                          // #header_open_st: hidden at top, visible on scroll (on all devices)
                                            if (header) {
                                                header.style.visibility = scrolled ? 'visible' : 'hidden';
                                                  }
                                                  });


document.addEventListener('DOMContentLoaded', function () {
  const labels = document.querySelectorAll('.apps'); // Get all elements with class 'app2'

  const fixedText = 'Search for ';
  const words = ['Bleuface…','Sunscreen…', 'Maybelline…', 'Sheet Mask…', 'Bioaqua…', 'Miss Rose…', 'Sheglam…'];
  const delay = 65;
  const pauseBetweenWords = 1500;

  labels.forEach(label => {
    let wordIndex = 0;
    let charIndex = 0;
    let typing = true;

    function typeLabel() {
      if (typing) {
        if (charIndex < words[wordIndex].length) {
          label.textContent = fixedText + words[wordIndex].substring(0, charIndex + 1);
          charIndex++;
          setTimeout(typeLabel, delay);
        } else {
          typing = false;
          setTimeout(typeLabel, pauseBetweenWords);
        }
      } else {
        if (charIndex > 0) {
          label.textContent = fixedText + words[wordIndex].substring(0, charIndex - 1);
          charIndex--;
          setTimeout(typeLabel, delay / 2);
        } else {
          typing = true;
          wordIndex = (wordIndex + 1) % words.length;
          setTimeout(typeLabel, delay);
        }
      }
    }

    // Initialize label with fixed text
    label.textContent = fixedText;
    typeLabel();
  });
});



